import { createBrowserRouter } from 'react-router-dom';
import { t } from 'i18next';

import { ErrorScreen } from '@sternum/web/components/ErrorScreen';
import { alertsRoutes } from '@sternum/web/features/alerts/routes';
import { attacksRoutes } from '@sternum/web/features/attacks/routes';
import { auditLogRoutes } from '@sternum/web/features/auditLog/routes';
import { authRoutes } from '@sternum/web/features/auth/routes';
import { clientsRoutes } from '@sternum/web/features/client/routes';
import { dashboardRoutes } from '@sternum/web/features/dashboard/routes';
import { deviceRoutes } from '@sternum/web/features/device/routes';
import { fleetsViewRoutes } from '@sternum/web/features/fleetsView/routes';
import { integrationsRoutes } from '@sternum/web/features/integrations/routes';
import { logsRoutes } from '@sternum/web/features/logs/routes';
import { productRoutes } from '@sternum/web/features/product/routes';
import { userRoutes } from '@sternum/web/features/user/routes';
import { widgetRoutes } from '@sternum/web/features/widget/routes';
import { workloadsRoutes } from '@sternum/web/features/workloads/routes';
import { namespaces } from '@sternum/web/services/i18n';

import { Root } from './Root';
import { RoutesWrapper } from './RoutesWrapper';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RoutesWrapper />,
    errorElement: <ErrorScreen />,
    children: [
      {
        path: '/',
        /**
         * This page is not wrapped with `ProtectedRoute` because we cant use `useMe` endpoint
         * before we set up a client context. Instead Root handles unauthorized state and
         * redirection to last used client without relying on `useMe` endpoint
         */
        element: <Root />,
      },
      ...auditLogRoutes,
      ...authRoutes,
      ...alertsRoutes,
      ...attacksRoutes,
      ...clientsRoutes,
      ...fleetsViewRoutes,
      ...integrationsRoutes,
      ...logsRoutes,
      ...userRoutes,
      ...dashboardRoutes,
      ...deviceRoutes,
      ...widgetRoutes,
      ...productRoutes,
      ...workloadsRoutes,
      {
        path: '*',
        Component: () => (
          <ErrorScreen
            reason="not-found"
            title={t('errors.notFound.title', { ns: namespaces.common })}
            description={t('errors.notFound.description', { ns: namespaces.common })}
          />
        ),
      },
    ],
  },
]);
